/* SUNBORN 9/29 — Split-colorway cards (sunborn.color_siblings).
   Loaded (deferred, guarded) only by cards that have siblings — see
   snippets/product-grid-option.liquid.

   1. CAROUSEL DEDUPE: inside .sunborn-clean-carousel (homepage "What's
      New" etc.), only the FIRST card of each colorway group is kept;
      later cards from the same group are removed before/after Swiper
      init (Swiper runs with observer:true, and we call update()).

   1b. COLLECTION GRID COLLAPSE (9/30): on /collections/* grids (.sbcg-grid),
      one card per colorway group by default (first in sort order wins);
      the other colorways are hidden (not removed) and stay reachable via
      the card's sibling swatches. EXPANDED (every colorway shown) when:
        - a color / colorway filter is active in the URL,
        - the collection is a line or color collection (handle starts with
          anansenova, group-, featured-in-, shop-by-color, color-),
        - on /search.
      Re-applies after AJAX filter / sort re-renders.

   2. IN-PLACE SIBLING PREVIEW: tapping a sibling dot (.sb-sib-link)
      swaps the card's image, hover image, title, price and both card
      links to that colorway instead of navigating. Tapping the
      already-active sibling dot navigates to it. Tapping the card's own
      dot (.item-data) restores the original product. While previewing,
      the card's quick-size / quick-add / quick-cart controls are hidden,
      because they are wired to the original product's variants.

   9/29 fix: the hover (.img2) image now swaps to the sibling's own
   second image (data-sb-img2). If the sibling has no second image, the
   card is flagged .sb-no-img2 and the main image stays visible on hover
   instead of fading to a blank slot. */
(function () {
  if (window.__sbSibCards) return;
  window.__sbSibCards = true;

  var css =
    '.single-product-wrap.sb-sib-previewing.sb-no-img2 .img2{display:none!important}' +
    '.single-product-wrap.sb-sib-previewing.sb-no-img2 .img1,' +
    '.single-product-wrap.sb-sib-previewing.sb-no-img2:hover .img1{opacity:1!important;visibility:visible!important;transform:none!important}' +
    '.single-product-wrap.sb-sib-previewing .sb-quick-size,' +
    '.single-product-wrap.sb-sib-previewing .sb-mqa-plus,' +
    '.single-product-wrap.sb-sib-previewing .sb-quick-cart-btn{display:none!important}' +
    '.sb-sib-link{cursor:pointer}' +
    '.sb-grp-collapsed{display:none!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function dedupe() {
    var wrappers = document.querySelectorAll('.sunborn-clean-carousel .swiper-wrapper');
    Array.prototype.forEach.call(wrappers, function (w) {
      var seen = {};
      var removed = false;
      Array.prototype.slice.call(w.children).forEach(function (slide) {
        var g = slide.querySelector('[data-sb-group]');
        if (!g) return;
        var k = g.getAttribute('data-sb-group');
        if (!k) return;
        if (seen[k]) {
          slide.parentNode.removeChild(slide);
          removed = true;
        } else {
          seen[k] = true;
        }
      });
      if (removed) {
        var sw = w.parentNode && w.parentNode.swiper;
        if (sw && typeof sw.update === 'function') sw.update();
      }
    });
  }

  /* ---- 1b. collection grid collapse ---- */
  var EXPAND_HANDLES = /^(anansenova|group-|featured-in-|shop-by-color|color-)/i;

  function gridShouldExpand() {
    var path = window.location.pathname;
    if (/^\/search/.test(path)) return true;
    var m = path.match(/\/collections\/([^\/?#]+)/);
    if (!m) return true;
    if (EXPAND_HANDLES.test(decodeURIComponent(m[1]))) return true;
    var q = window.location.search;
    if (q) {
      var params = new URLSearchParams(q);
      var colorFilter = false;
      params.forEach(function (v, key) {
        if (/^filter\./i.test(key) && /(colou?r|colorway)/i.test(key)) colorFilter = true;
      });
      if (colorFilter) return true;
    }
    return false;
  }

  function collapseGrids() {
    var grids = document.querySelectorAll('.sbcg-grid');
    if (!grids.length) return;
    var expand = gridShouldExpand();
    Array.prototype.forEach.call(grids, function (grid) {
      var seen = {};
      Array.prototype.slice.call(grid.children).forEach(function (item) {
        var g = item.querySelector('[data-sb-group]');
        var k = g && g.getAttribute('data-sb-group');
        if (expand || !k) {
          item.classList.remove('sb-grp-collapsed');
          return;
        }
        if (seen[k]) item.classList.add('sb-grp-collapsed');
        else {
          seen[k] = true;
          item.classList.remove('sb-grp-collapsed');
        }
      });
    });
  }

  function runAll() { dedupe(); collapseGrids(); }
  runAll();
  document.addEventListener('DOMContentLoaded', runAll);
  window.addEventListener('load', runAll);

  var queued = false;
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () { queued = false; collapseGrids(); });
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.addEventListener('popstate', function () { setTimeout(collapseGrids, 50); });

  function money(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return null;
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) {
      return Shopify.formatMoney(n, window.money_format);
    }
    return '$' + (n / 100).toFixed(2);
  }

  function parts(wrap) {
    var imgs = wrap.querySelectorAll('.product-image a.pro-img img');
    var img2wrap = wrap.querySelector('.product-image a.pro-img .img2');
    return {
      img: imgs[0] || null,
      img2: img2wrap ? img2wrap.querySelector('img') : null,
      links: wrap.querySelectorAll('.product-image a.pro-img, .product-content h6 a'),
      titleA: wrap.querySelector('.product-content h6 a'),
      newPrice: wrap.querySelector('.price-box .new-price'),
      oldPrice: wrap.querySelector('.price-box .old-price')
    };
  }

  function saveOrig(wrap, p) {
    if (wrap.__sbOrig) return;
    wrap.__sbOrig = {
      src: p.img ? p.img.getAttribute('src') : null,
      srcset: p.img ? p.img.getAttribute('srcset') : null,
      src2: p.img2 ? p.img2.getAttribute('src') : null,
      srcset2: p.img2 ? p.img2.getAttribute('srcset') : null,
      hrefs: Array.prototype.map.call(p.links, function (a) { return a.getAttribute('href'); }),
      title: p.titleA ? p.titleA.textContent : null,
      titleAttr: p.titleA ? p.titleA.getAttribute('title') : null,
      price: p.newPrice ? p.newPrice.innerHTML : null,
      old: p.oldPrice ? p.oldPrice.innerHTML : null,
      oldDisplay: p.oldPrice ? p.oldPrice.style.display : null
    };
  }

  function setActive(fw) {
    var block = fw.closest('.option-block');
    if (!block) return;
    Array.prototype.forEach.call(block.querySelectorAll('form-wrap'), function (x) {
      x.classList.remove('active-variant');
    });
    fw.classList.add('active-variant');
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.sb-sib-link');
    if (link) {
      var wrap = link.closest('.single-product-wrap');
      var fw = link.closest('form-wrap');
      if (!wrap || !fw) return;
      if (fw.classList.contains('active-variant')) return; /* second tap: navigate */
      e.preventDefault();
      e.stopPropagation();
      var p = parts(wrap);
      saveOrig(wrap, p);
      if (p.img && link.dataset.sbImg) {
        p.img.setAttribute('src', link.dataset.sbImg);
        p.img.removeAttribute('srcset');
      }
      if (p.img2 && link.dataset.sbImg2) {
        p.img2.setAttribute('src', link.dataset.sbImg2);
        p.img2.removeAttribute('srcset');
        wrap.classList.remove('sb-no-img2');
      } else {
        wrap.classList.add('sb-no-img2');
      }
      Array.prototype.forEach.call(p.links, function (a) { a.setAttribute('href', link.getAttribute('href')); });
      if (p.titleA && link.dataset.sbTitle) {
        p.titleA.textContent = link.dataset.sbTitle;
        p.titleA.setAttribute('title', link.dataset.sbTitle);
      }
      var np = money(link.dataset.sbPrice);
      if (p.newPrice && np) p.newPrice.innerHTML = np;
      if (p.oldPrice) {
        var cmp = parseInt(link.dataset.sbCompare, 10);
        var pr = parseInt(link.dataset.sbPrice, 10);
        if (cmp && cmp > pr) {
          p.oldPrice.innerHTML = money(cmp);
          p.oldPrice.style.display = '';
        } else {
          p.oldPrice.style.display = 'none';
        }
      }
      setActive(fw);
      wrap.classList.add('sb-sib-previewing');
      return;
    }

    /* Restore to the card's own colorway. The own swatch is .item-data for
       products WITH a Color option, but a no-Color split bundle (e.g. a
       Bra + Flare Leggings Set) renders its own swatch as .sb-sib-self with
       NO .item-data, so match that too — otherwise tapping the card's own
       dot after previewing a sibling never restores the image. */
    var own = e.target.closest && (e.target.closest('.item-data') || e.target.closest('.sb-sib-self'));
    if (own) {
      var w2 = own.closest('.single-product-wrap');
      if (!w2 || !w2.__sbOrig || !w2.classList.contains('sb-sib-previewing')) return;
      var p2 = parts(w2);
      var o = w2.__sbOrig;
      if (p2.img) {
        if (o.src) p2.img.setAttribute('src', o.src);
        if (o.srcset) p2.img.setAttribute('srcset', o.srcset);
      }
      if (p2.img2) {
        if (o.src2) p2.img2.setAttribute('src', o.src2);
        if (o.srcset2) p2.img2.setAttribute('srcset', o.srcset2);
      }
      Array.prototype.forEach.call(p2.links, function (a, i) {
        if (o.hrefs[i] != null) a.setAttribute('href', o.hrefs[i]);
      });
      if (p2.titleA && o.title != null) {
        p2.titleA.textContent = o.title;
        if (o.titleAttr != null) p2.titleA.setAttribute('title', o.titleAttr);
      }
      if (p2.newPrice && o.price != null) p2.newPrice.innerHTML = o.price;
      if (p2.oldPrice) {
        if (o.old != null) p2.oldPrice.innerHTML = o.old;
        p2.oldPrice.style.display = o.oldDisplay || '';
      }
      w2.classList.remove('sb-sib-previewing');
      w2.classList.remove('sb-no-img2');
      /* For a no-Color bundle the own swatch is .sb-sib-self (not .item-data),
         so main.js's item-data handler won't run to re-activate it — do it
         here. For .item-data cards main.js handles active-variant as usual. */
      var selfFw = own.closest('.sb-sib-self');
      if (selfFw) setActive(selfFw);
    }
  }, true);
})();
